import { ToastContainer } from "react-toastify";
import React, { memo } from "react";

interface Props {
  children: React.ReactNode;
}

export const AppNotificationsProvider = memo<Props>(({ children }) => {
  return (
    <>
      <ToastContainer
        position={"bottom-right"}
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {children}
    </>
  );
});
